import {ActivatedRoute, Router} from '@angular/router';
import {Component, HostListener} from '@angular/core';
import {ApiError, HttpStatusCodesEnum, ServerResponseData} from '@spa/api';

import {BaseComponent} from '../base.component';
import {LanguageService} from '../language.service';
import {InternalServerErrorKey, MobileBreakpoint, TabletBreakpoint} from '../constants';
import {InitialDataValidationException} from '../exceptions';

@Component({
	template: ''
})
export abstract class BaseActiveRouteComponent<ResolverDataType> extends BaseComponent {
	public loading: boolean;
	public isMobile: boolean;
	public isTablet: boolean;

	protected constructor(
		protected languageService: LanguageService,
		protected router: Router,
		protected activatedRoute: ActivatedRoute,
	) {
		super(languageService, router, activatedRoute);
		this.detectMobile();
	}

	private validateInitialData(data: ServerResponseData<ResolverDataType>): void {
		if (data && data.status !== HttpStatusCodesEnum.Ok) {
			throw new InitialDataValidationException(
				data.messages,
				[data.status],
				data.data as ApiError[]
			);
		}
	}

	doInitialDataValidationCheck(data: ServerResponseData<ResolverDataType>, callback: () => void): void {
		try {
			this.validateInitialData(data);
			callback();
		} catch (exception) {
			if (exception instanceof InitialDataValidationException) {
				const internalErrorMessage = this.languageService.getInstantTranslationByKey(InternalServerErrorKey);

				this.navigateToErrorPage(HttpStatusCodesEnum.InternalServerError, [internalErrorMessage]);
			} else {
				console.error(exception);
			}
		}
	}

	@HostListener('window:resize', ['$event'])
	detectMobile(): void {
		this.isMobile = window.outerWidth <= MobileBreakpoint;
		this.isTablet = window.outerWidth <= TabletBreakpoint;

	}
}
